import { Vue } from "vue-property-decorator";
import KkSpinner from "./KkSpinner";
Vue.mixin({
    components: {
        KkSpinner: KkSpinner
    }
});



//////////////////
// WEBPACK FOOTER
// ./app/ts/components/index.ts
// module id = 75
// module chunks = 0